import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  initialize() {
    const openModal = event => {
      // SAME PAGE URL

      const currentPath = this.data.get('url');
      const navigationUrl = new URL(event.detail.url);

      const pathIncludesPageUrl = navigationUrl.pathname.indexOf(currentPath) > -1;
      const pathHasMoreSubPathsThanPageUrl = navigationUrl.pathname.split('/').length > currentPath.split('/').length;

      if (pathIncludesPageUrl && !pathHasMoreSubPathsThanPageUrl) {
        document.body.classList.add('has-loading-spinner');
        document.body.classList.add('modal-open');
        this.element.classList.add('translate-x-0');
      }

      return true;
    };

    //document.addEventListener('turbo:before-fetch-request', openModal);

    document.addEventListener('turbo:before-render', () => {
      //document.removeEventListener('turbo:before-fetch-request', openModal);
      document.body.classList.remove('modal-open');
      document.body.classList.remove('has-loading-spinner');
    });
  }

  connect() {
    if (this.data.get('waiting-for-autobid-extension') == 'true') {
      document.body.classList.add('has-forced-loading-spinner');
      document.body.classList.add('modal-open');
    }
  }
}
